<template>
  <div
    :class="
      $twMerge(
        'wr-button-shell overflow-hidden bg-[linear-gradient(95.01deg,#BDB1FF_2.72%,#6952ED_95.35%)] rounded-full p-px max-w-max tracking-wider',
        props.noHover ? '' : 'transition-all duration-300 hover:shadow-[0_0_20px_rgba(189,177,255,0.5)] hover:scale-[1.02]',
        props.outlined && 'bg-none',
        props.containerClass
      )
    "
  >
    <NuxtLink
      v-if="link"
      :to="link"
      :target="isExternal(link) ? '_blank' : undefined"
      v-bind="$attrs"
      :class="
        $twMerge(
          'h-full px-4 lg:px-5 py-1.5 lg:py-2.5 rounded-full border-0 bg-[linear-gradient(95.99deg,#6C59B5_3.69%,#261640_96.65%)] text-white inline-flex items-center justify-center',
          props.noHover ? '' : 'transition-all duration-300 hover:brightness-110',
          props.outlined && 'bg-none text-foreground',
          props.appendClass
        )
      "
    >
      <slot>Button</slot>
    </NuxtLink>
    <Button
      v-else
      unstyled
      size="small"
      v-bind="$attrs"
      :class="
        $twMerge(
          'h-full px-4 lg:px-5 py-1.5 lg:py-2.5 rounded-full border-0 bg-[linear-gradient(95.99deg,#6C59B5_3.69%,#261640_96.65%)] text-white',
          props.noHover ? '' : 'transition-all duration-300 hover:brightness-110',
          props.outlined && 'bg-none text-foreground',
          props.appendClass
        )
      "
    >
      <slot>Button</slot>
    </Button>
  </div>
</template>

<script setup lang="ts">
const Button = defineAsyncComponent(() => import('primevue/button'));
const { $twMerge } = useNuxtApp();



type Props = {
  appendClass?: string;
  containerClass?: string;
  outlined?: boolean;
  link?: string;
  noHover?: boolean;
};

const props = withDefaults(defineProps<Props>(), {});
const isExternal = (link:string | undefined) => {
  if(typeof link === 'string'){
  return  /^https?:\/\//.test(link)
  } else {
    return false;
  }
}


</script>
